import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnnotaterSad = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 8 8",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M1 0h1.5v1.5H1zM5.5 0H7v1.5H5.5zM1 5.5h1.5V7H1zM5.5 5.5H7V7H5.5zM2.5 4h3v1.5h-3z"
	})
});
export default SvgAnnotaterSad;
